import { createFeatureSelector, createSelector } from "@ngrx/store";
import { LoadingState, getError } from "@core/models";
import { printKiosksAdapter, PrintKiosksState } from "./print-kiosks.state";

const selectFeature = createFeatureSelector<PrintKiosksState>('printKiosks');

const { selectAll, selectTotal } = printKiosksAdapter.getSelectors(selectFeature);

const selectCallState = createSelector(selectFeature, (state) => state.callState);
const selectIsLoading = createSelector(selectFeature, (state) => state.callState === LoadingState.LOADING);
const selectIsLoaded = createSelector(selectFeature, (state) => state.callState === LoadingState.LOADED);
const selectError = createSelector(selectCallState, (callState) => getError(callState));

const selectPrintKiosksByPrinter = (printerId: string) =>
  createSelector(selectAll, (kiosks) => kiosks.filter((x) => x.printerId === printerId));

const selectPrintKiosksByDevice = (deviceId: string) =>
  createSelector(selectAll, (kiosks) => kiosks.filter((x) => x.deviceId === deviceId));

export const PrintKiosksSelectors = {
  callState: selectCallState,
  all: selectAll,
  total: selectTotal,
  isLoading: selectIsLoading,
  isLoaded: selectIsLoaded,
  error: selectError,
  printKiosksByPrinter: (printerId: string) => selectPrintKiosksByPrinter(printerId),
  printKiosksByDevice: (deviceId: string) => selectPrintKiosksByDevice(deviceId),
};
